import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

export const Link = styled.span`
  color: #4585ff;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;

  cursor: pointer;
  text-decoration-line: underline;
`;

export const Title = styled.span`
  color: #333333;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 14px;
  text-transform: uppercase;
`;
